ajaxifyCollection = function (settings) {
	var linkParent = '.pagination-content';
	var parentContainer = '[data-infinite="true"]';
	var endlessScrollContainer = '[data-infinite="true"]';
	var endlessOffset = 600;
	var ajaxinateContainer = '.Ajaxinate';
	var ajaxinateLink = '.pagination__item--next-page';
	var fade = 'fast';
	var textChange = 'Loading';
	var loader = '.gant-loading-spinner--wrapper';
	var linkElem;
	var contentContainer;
	var pageNumber;
	var pageType;
	var action;
	var moreURL;
	var moreURLCheck;
	var currentPage;
	contentContainer = endlessScrollContainer
	var maxPages = $(linkParent).data('pages');

	var loadedLastPage = false;
  var isLoading = false;

	$.loadMore = function () {

    if (isLoading || loadedLastPage) return;

		moreURL = document.querySelector('.gant-loading-spinner--wrapper')
		if (!moreURL) {
			return;
		}
		moreURL = moreURL.dataset.href;

    isLoading = true;
		$(linkParent).hide();
		$(loader).show();

		$.ajax({
			type: 'GET',
			dataType: 'html',
			url: moreURL,
			success: function (data) {
				if (currentPage == maxPages) {
					loadedLastPage = true;
				}
				var filteredData = $(data).find(contentContainer);
				var filteredDataProducts = filteredData[0].innerHTML;
				var newProdHtml = $(filteredDataProducts);
				$(contentContainer).append(newProdHtml).hide().fadeIn(fade);
				var newProducts = newProdHtml;
				moreURL = $(data).find(".pagination .pagination-next").attr('href');
				$('.paginate-load-more-wrap').html($(data).find('.paginate-load-more-wrap').html())
				$(".pagination").html($(data).find(".pagination").html());
				if (typeof wishlistData.init === "function") {
					setTimeout(() => {
						wishlistData.init();
					}, 800);
				}
				collectionGetVariations(settings, newProducts);
				$(linkParent).hide();

				$(loader).hide();
        isLoading = false;
			},
			timeout: 15000,
			error: function (jqXHR, textStatus, errorThrown) {
				$(loader).hide();
        isLoading = false;
				if (textStatus === "timeout") {
					$(linkElem).text("Load more");
					$(linkElem).css('opacity', 1);
				}
			}
		});
	};

	const targetElement = document.querySelector('.paginate-load-more-wrap');
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				$.loadMore();
			}
		});
	}, {
		root: null,
		rootMargin: '0px',
		threshold: 1.0
	});
	observer.observe(targetElement);
};
